import { render } from "./DashboardVendorTable.vue?vue&type=template&id=3d8b49b1"
import script from "./DashboardVendorTable.vue?vue&type=script&lang=js"
export * from "./DashboardVendorTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__